import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

export type RenameTagFormData = {name: string; rename_to: string};

export type RenameTagSErrorResponse = Api.Response.Failure<{string: boolean}>;

export type RenameTagSuccessResponse = Api.Response.Success<never>;

export const useRenameTag = (): UseMutationResult<
    RenameTagSuccessResponse,
    Error,
    {formData: RenameTagFormData; id: number}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({formData, id}) =>
            request({
                formData,
                locale,
                method: 'POST',
                url: `/ui/partner/tags/${id}/rename/`,
            }),
    });
};

export type DeleteTagSuccessResponse = Api.Response.Success<never>;

export const useDeleteTag = (): UseMutationResult<
    DeleteTagSuccessResponse,
    Error,
    {id: number}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({id}) =>
            request({
                locale,
                method: 'POST',
                url: `/ui/partner/tags/${id}/delete/`,
            }),
    });
};
